<template>
  <div class="rank-content">
    <div class="content-title">教室直播排行</div>
    <div class="rank-box" v-if="liveInfo && liveInfo.length">
      <div
        class="rank-item"
        :style="{ background: filetrForLiveStatusColor(index) }"
        v-for="(liveInfoItem, index) in liveInfo"
        :key="index"
      >
        <div class="left-building-info">
          <div class="ranking">
            <template v-if="index <= 2">
              <img v-if="index === 0" src="../../../assets/img/operationOverview/first_rank.png" alt="" />
              <img v-if="index === 1" src="../../../assets/img/operationOverview/second_rank.png" alt="" />
              <img v-if="index === 2" src="../../../assets/img/operationOverview/third_rank.png" alt="" />
            </template>
            <template v-else>
              <span class="end-rank">{{ index + 1 }}</span>
            </template>
          </div>
          <div class="building-info text-overflow-one">
            {{ liveInfoItem.classroomName }}
          </div>
          <!-- <div class="classroom-name">{{ '3116' }}</div> -->
        </div>
        <div class="right-live-count">
          <div class="text-tip">教室直播</div>
          <div class="live-count">
            <span class="count-unit">{{ liveInfoItem.liveCount }}</span>
            <span>次</span>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" />
    </div>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
export default {
  name: 'classCard',
  props: {
    liveInfo: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      Empty
    }
  },
  methods: {
    filetrForLiveStatusColor(index) {
      let res = '#fff'
      switch (index) {
        case 0:
          res = 'linear-gradient(90deg, #FBDFD7 0%, #FDF4F1 100%)'
          break
        case 1:
          res = 'linear-gradient(90deg, #E1E1FC 0%, #FDF3F0 100%)'
          break
        case 2:
          res = 'linear-gradient(90deg, #FCF0E1 0%, #FDF4F1 100%)'
          break
        case 3:
          res = 'linear-gradient(90deg, #FFF9F9 0%, #FEFAF9 100%)'
          break
      }
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.rank-content {
  padding: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-title {
    height: 16px;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 16px;
    color: #1e2228;
  }
  .no-data {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rank-box {
    flex: 1;
    height: calc(100% - 16px);
    display: flex;
    flex-direction: column;
  }
}
.rank-item {
  width: 100%;
  height: 20%;
  padding: 13px 16px;
  color: #1e2228;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-building-info {
  flex: 1;
  width: calc(100% - 110px);
  padding-right: 10px;
  display: flex;
  align-items: center;
  .ranking {
    width: 28px;
    height: 24px;
    text-align: center;
    .end-rank {
      line-height: 24px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .building-info {
    flex: 1;
    padding-left: 16px;
    padding-right: 6px;
  }
  .building-info,
  .classroom-name {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
}
.right-live-count {
  width: 110px;
  display: flex;
  align-items: center;
  font-size: 12px;
  .text-tip {
    margin-right: 10px;
  }
  .count-unit {
    font-size: 16px;
    margin-right: 4px;
    font-weight: 600;
  }
}
</style>
